import {InformationAssetUser} from "../../../models/information-asset-user";
import {useSelector} from "react-redux";
import {RootState} from "../../../../../redux/store";

export function useFetchInformationAssetUsers(): InformationAssetUser[] {
    return useSelector(
        (rootState: RootState) => rootState.informationAssetUser.informationAssetUserPEV.value ?? []
    )
}